import React, { FC } from 'react'

import { TermsProps } from './types'
import { TermsModalContent } from './TermsModalContent'

export type TermsOfUseProps = TermsProps

export const TermsOfUse: FC<TermsOfUseProps> = ({ open, setCurrentlyOpenTermsModal }) => {
  return (
    <TermsModalContent
      termsType={'termsOfUse'}
      open={open}
      setCurrentlyOpenTermsModal={setCurrentlyOpenTermsModal}
    />
  )
}
